// extracted by mini-css-extract-plugin
export default {"productDescription":"lfa-z","featuredDescription":"mfa-z","description":"nfa-z","more":"ofa-z","descriptionSku":"pfa-z"};